<i class="loader one" *ngIf="type === 'one'"></i>
<i class="loader two" *ngIf="type === 'two'"></i>